import React from 'react';
import { motion } from 'framer-motion';
import { X, AlertCircle } from 'lucide-react';
export function RealityCheck() {
  const problems = ['Páginas web en inglés que no entienden', 'Agentes que solo quieren vender sin explicar', 'Precios que parecen imposibles', 'Letras pequeñas que nadie les traduce', 'Planes que no cubren lo que realmente necesitan'];
  return <section className="py-8 md:py-20 bg-navy text-white relative" data-id="element-302">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-303" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-305">
          <div className="flex justify-center mb-4" data-id="element-306">
            <AlertCircle className="w-12 h-12 text-gold" data-id="element-307" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-308">
            LA REALIDAD QUE NADIE QUIERE VER
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-309">
            Seamos honestos. Vivir en Estados Unidos sin un seguro de salud
            adecuado es como manejar sin cinturón de seguridad. Todo va bien...
            hasta que no va bien.
          </p>
        </motion.div>

        <div className="bg-navy-light rounded-2xl p-8 md:p-10 shadow-2xl border border-white/10" data-id="element-310">
          <p className="text-lg mb-8 text-center" data-id="element-311">
            El problema no es que las familias latinas no quieran protegerse. El
            problema es que nadie les ha explicado sus opciones en su idioma,
            con honestidad, y sin presionarlas. Muchos han intentado buscar
            seguros y se han encontrado con:
          </p>

          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-312">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-navy p-4 rounded-lg border border-white/5" data-id="element-313">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-314">
                  <X className="w-5 h-5 text-red-400" data-id="element-315" />
                </div>
                <span className="text-lg" data-id="element-316">{problem}</span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="mt-10 text-center" data-id="element-317">
            <p className="text-xl font-serif italic text-gold mb-2" data-id="element-318">
              ¿Te suena familiar?
            </p>
            <p className="text-2xl font-bold" data-id="element-319">Eso termina hoy.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}